<template>
  <i class="help-tip" :title="text">?</i>
</template>

<script>
export default {
  name: 'HelpTip',
  props: {
    text: { type: String, default: '' },
  },
}
</script>

<style scoped>
.help-tip {
  align-items: center;
  background: #e5e7eb;
  border-radius: 50%;
  color: #6b7280;
  cursor: help;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  height: 15px;
  justify-content: center;
  line-height: 1;
  width: 15px;
}

.help-tip:hover {
  background: #c7d2fe;
  color: #4338ca;
}
</style>
